import $ from 'jquery';
import { Swiper, EffectFade, Navigation } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

$(window).on('load', () => {
  $('.carousel__preview').remove();
  const carouselEl = document.querySelectorAll('.carousel');

  function syncTabsState(carousel) {
    const mainCarousel = carousel.el.closest('.carousel');
    const { activeIndex } = carousel;
    const activeSlide = carousel.slides[activeIndex];
    const allTabs = mainCarousel.querySelectorAll('.carousel__tab');

    allTabs.forEach((tab) => {
      const isSelected = Number(tab.dataset.index) === activeIndex;
      const isInActiveSlide = tab.closest('.swiper-slide') === activeSlide;

      const isActiveTab = isSelected && isInActiveSlide;
      tab.classList.toggle('active', isActiveTab);
      tab.setAttribute('aria-selected', String(isActiveTab));
      if (isActiveTab) {
        tab.removeAttribute('tabindex');
      } else {
        tab.setAttribute('tabindex', '-1');
      }
    });
  }

  function refreshTabindex(carousel) {
    const { activeIndex } = carousel;

    // Hidden slides get aria-hidden + inert from HideOffscreenSlides.
    carousel.slides.forEach((slide, index) => {
      // eslint-disable-next-line no-param-reassign
      slide.tabIndex = index === activeIndex ? 0 : -1;
    });

    syncTabsState(carousel);
  }

  function focusActiveTab(carousel, index) {
    const activeSlide = carousel.slides[carousel.activeIndex];
    const activeTabs = activeSlide && activeSlide.querySelector('.carousel__tabs');
    const tab = activeTabs && activeTabs.querySelector(`.carousel__tab[data-index="${index}"]`);

    if (tab) {
      tab.focus();
    }
  }

  function carouselNavigation(carousel, controls) {
    controls.forEach((btn) => {
      btn.addEventListener('click', () => {
        const totalSlides = carousel.slides.length;
        const activeSlideIndex = carousel.activeIndex;

        if (btn.className.includes('carousel__nav--prev')) {
          if (activeSlideIndex === 0) {
            carousel.slideTo(totalSlides - 1);
          } else {
            carousel.slidePrev();
          }
        } else {
          // eslint-disable-next-line
          if (activeSlideIndex === totalSlides - 1) {
            carousel.slideTo(0);
          } else {
            carousel.slideNext();
          }
        }

        syncTabsState(carousel);

        // Mobile controls live inside each slide and go inert with it; keep
        // keyboard focus on the same control in the new active slide.
        if (btn.closest('.swiper-slide')) {
          const isPrev = btn.className.includes('carousel__nav--prev');
          carousel.slides[carousel.activeIndex]
            .querySelector(isPrev ? '.carousel__nav--prev' : '.carousel__nav--next')
            .focus();
        }
      });
    });
  }

  function handleTabKeydown(event, carousel, totalSlides) {
    const currentIndex = Number(event.currentTarget.dataset.index);
    let newIndex;

    switch (event.key) {
      case 'ArrowRight':
        newIndex = (currentIndex + 1) % totalSlides;
        break;
      case 'ArrowLeft':
        newIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = totalSlides - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    carousel.slideTo(newIndex);
    syncTabsState(carousel);
    focusActiveTab(carousel, newIndex);
  }

  carouselEl.forEach((block) => {
    const prevBtnClass = '.carousel__nav--prev';
    const nextBtnClass = '.carousel__nav--next';
    const slider = block.querySelector('.carousel__swiper-container');

    const nextBtns = block.querySelectorAll(nextBtnClass);
    const prevBtns = block.querySelectorAll(prevBtnClass);

    const carouselParent = $(slider).closest('.carousel');

    const tabs = carouselParent.find('.carousel__category');
    const carouselTabs = carouselParent.find('.carousel__tabs');
    const totalSlides = tabs.length;

    const carousel = new Swiper(slider, {
      modules: [Navigation, EffectFade, HideOffscreenSlides],
      speed: 200,
      effect: 'fade',
      slidesPerView: 1,
      spaceBetween: 0,
      preloadImages: true,
      breakpoints: {
        992: {
          touchEventsTarget: 'wrapper',
          touchRatio: 0,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
        },
      },
      on: {
        init() {
          refreshTabindex(this);
        },
        slideChange() {
          refreshTabindex(carousel);
        },
        slideChangeTransitionEnd() {
          refreshTabindex(carousel);
        },
      },
    });

    function debounce(func, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }

    function handleClick() {
      const currentIndex = Number($(this).data('index'));
      carousel.slideTo(currentIndex);
      syncTabsState(carousel);
    }

    carouselTabs.each((containerIndex, container) => {
      const $container = $(container);
      $container.text('');
      const blockId = block.id;

      for (let i = 0; i < tabs.length; i++) {
        const categoryText = tabs[i].textContent.trim();

        if (!categoryText) {
          // eslint-disable-next-line no-continue
          continue;
        }

        const newTab = $('<button></button>', {
          class: 'carousel__tab',
          id: `${blockId}-panel-${containerIndex}-tab-${i}`,
          'data-index': i,
          tabindex: -1,
          role: 'tab',
          'aria-selected': 'false',
          'aria-controls': `${blockId}-panel-${i}`,
        });
        newTab.text(categoryText);
        $container.append(newTab);
      }
    });

    carouselNavigation(carousel, nextBtns);
    carouselNavigation(carousel, prevBtns);

    carouselTabs.on('click', '.carousel__tab', debounce(handleClick, 500));
    carouselTabs.on('keydown', '.carousel__tab', (event) => {
      handleTabKeydown(event, carousel, totalSlides);
    });

    syncTabsState(carousel);
  });
});